const zh = {
  home: {
    navHome: '首页',
    navTools: '工具',
    navDocs: '教学',
    navAirdrop: '空投',
    navRebate: '交易所注册',
    login: '登录',
    register: '注册',
    heroTitle: 'GHOST',
    heroSubtitle: 'Web3 社群 · 空投活动 · 交易教学',
    heroDesc: '加入我们，获取最新的空投资讯、系统化的交易教学和专业的看盘工具',
    joinNow: '立即加入',
    learnMore: '了解更多',
    sectionTools: '看盘工具',
    airdropTeaserTitle: '社区空投活动',
    airdropTeaserDesc: '精选优质空投项目，参与社区专属空投，不错过每一个机会',
    marqueeRow1: '区块链   去中心化   智能合约   空投   DeFi   NFT   Web3   钱包   私钥   公链   Gas费   流动性   质押   哈希率   DAO   零知识证明   跨链桥   节点   共识机制   Layer2   代币经济学   链上治理   闪电网络   预言机   碎片化   熔铸   梅克尔树   非对称加密   分布式账本',
    marqueeRow2: '分布式账本   非对称加密   梅克尔树   熔铸   碎片化   预言机   闪电网络   链上治理   代币经济学   Layer2   共识机制   节点   跨链桥   零知识证明   DAO   哈希率   质押   流动性   Gas费   公链   私钥   钱包   Web3   NFT   DeFi   空投   智能合约   去中心化   区块链',
    bannerTitle: '数据驱动的',
    bannerHighlight: '交易决策',
    bannerDesc: '每一条信号背后，都是海量数据的深度分析与多维度验证',
    startLearning: '开始学习',
    ctaTitle: '准备好开始了吗？',
    ctaDesc: '注册即可参与空投活动，获取最新教学资源',
    freeRegister: '免费注册',
    proTitle: '解锁专业版',
    proDesc: '进阶服务 — 美股/加密市场入口、深度简报+标的筛选、工具完整权限+社群',
    proCta: '了解进阶方案',
    proHint: '美股/加密市场入口 · 深度简报+标的筛选 · 工具完整权限+社群',
    growthHeroSubtitle: '书籍 · 认知 · 学习路径',
    growthHeroDesc: '免费获取优质投资书籍推荐、财富认知文章和系统化学习资源',
    growthDocsTitle: '推荐书籍',
    growthDocsDesc: '精选投资经典，从入门到进阶，构建你的投资知识体系',
    celebrityTitle: '名人观点',
    celebrityDesc: '聆听投资大师的智慧，建立正确的财富思维',
    growthArticlesTitle: '财富认知',
    growthArticlesDesc: '理解财富本质，建立正确的投资思维',
    growthPathTitle: '学习路径',
    growthPathDesc: '从零开始，系统化掌握加密货币投资',
    growthLessonsTitle: '从0到1学交易',
    growthLessonsDesc: '先把交易基础、平台操作和学习资料理顺，再进入工具和行情。',
    growthLessonExchangeTitle: '交易所教程',
    growthLessonExchangeDesc: '下载、注册、返佣绑定和常见平台操作，先把账户基础搭好。',
    growthLessonBooksTitle: '推荐书籍',
    growthLessonBooksDesc: '用三本经典建立技术分析、交易系统和心态框架。',
    growthLessonPathTitle: '新手教学',
    growthLessonPathDesc: '从核心概念到实操路径，按阶段补齐交易学习基础。',
    proHeroSubtitle: '工具 · 数据 · 深度简报',
    proHeroDesc: '专业级交易工具、实时市场数据和深度分析简报，助力你的交易决策',
    proToolsTitle: '交易工具',
    proAirdropTitle: '空投活动',
    proAirdropDesc: '精选社区空投任务，查看奖励、时间和参与入口',
    loginToUse: '登录后使用',
    btcLive: 'BTC 实时价格',
    btcLoading: '加载中...',
    wechatTip: '微信号：admiraltyz',
    officialAccountTip: '关注公众号',
    sentimentTitle: '市场情绪',
    sentimentDesc: '实时加密市场情绪与关键指标',
    sentimentFng: '恐贪指数',
    sentimentFngExtremeFear: '极度恐惧',
    sentimentFngFear: '恐惧',
    sentimentFngNeutral: '中性',
    sentimentFngGreed: '贪婪',
    sentimentFngExtremeGreed: '极度贪婪',
    sentimentBtcDominance: 'BTC 市值占比',
    sentimentTotalMcap: '加密总市值',
    sentimentUpdated: '数据更新于',
    sentimentLoading: '加载中...',
    sentimentError: '数据获取失败',
    heatmapTitle: '板块热力图',
    heatmapDesc: '重点市场预览，完整板块热力图可进入工具箱查看',
    heatmapCryptoTitle: '加密市场',
    heatmapCryptoDesc: '核心币种 24h 表现',
    heatmapStocksTitle: '美股观察',
    heatmapStocksDesc: '科技与加密相关美股重点关注',
    heatmapFeatured: '重点',
    heatmapViewFull: '查看更多完整版',
    heatmapSectorLayer1: 'Layer 1',
    heatmapSectorDefi: 'DeFi',
    heatmapSectorMeme: 'Meme',
    heatmapSectorL2: 'Layer 2',
    heatmapSectorGaming: '游戏 / 元宇宙',
    heatmapSectorAi: 'AI',
    heatmapSectorOther: '其他',
    heatmapLoading: '加载中...',
    heatmapError: '数据获取失败',

    holdings13fTitle: '机构持仓 13F',
    holdings13fDesc: '跟踪顶级机构最新季度持仓变动',
    holdings13fWhy: '为什么关注机构持仓？',
    holdings13fWhyDesc: '顶级对冲基金和资管机构每季度必须向 SEC 披露持仓（13F 文件），这是了解"聪明钱"流向的最权威公开数据。跟踪机构仓位变化，可以帮助你发现潜在的市场趋势、验证投资逻辑，并在机构大举建仓或减仓时及时调整策略。',
    holdings13fLoading: '加载中...',
    holdings13fError: '数据获取失败',
    holdings13fStock: '股票名称',
    holdings13fShares: '持股数',
    holdings13fValue: '市值（千美元）',
    holdings13fWeight: '占比',
    holdings13fDate: '提交日期',
    holdings13fTotal: '持仓总市值',
    holdings13fTop10: '前十大持仓',
    holdings13fNoData: '暂无数据',
    holdings13fSource: '数据来源：SEC EDGAR',
    holdings13fViewDetail: '查看完整持仓 →',

    proNavOverview: '总览',
    proNavTools: '工具',
    proNavHeatmap: '热力图',
    proNavHoldings: '机构持仓',
    proNavFundamentals: '基本面',
    proNavAirdrop: '空投',
    proNavCommunity: '社区',

    cryptoDetailBack: '← 返回',
    cryptoDetailMarketCap: '市值',
    cryptoDetailCirculating: '流通量',
    cryptoDetailFng: '恐贪指数',
    cryptoDetailDominance: '主导地位',
    cryptoDetailPriceTrend: '价格走势',
    cryptoDetailOnchain: '链上指标',
    cryptoDetailExchangeInflow: '交易所净流入',
    cryptoDetailMinerSell: '矿工净卖压',
    cryptoDetailNvt: 'NVT 比率',
    cryptoDetailMvrv: 'MVRV',
    cryptoDetailWhaleSignal: '出货侦探',
    cryptoDetailWhaleHighRisk: '高危信号',
    cryptoDetailWhaleDetected: '发现量价背离 · 大户转移',
    cryptoDetailWhaleViewDetail: '查看详情 →',
    cryptoDetailWhaleNormal: '暂无明显异动',
    cryptoDetailTools: '相关工具',
    cryptoDetailChartPlaceholder: '价格走势图（实际版本接入 TradingView）',
    cryptoDetailTime1d: '1天',
    cryptoDetailTime1w: '1周',
    cryptoDetailTime1m: '1月',
    cryptoDetailLoading: '加载中...',
    cryptoDetailNotFound: '未找到该币种数据',

    instDetailBack: '← 返回',
    instDetailManager: '掌舵',
    instDetailQuarterly: '13F 季报',
    instDetailLatestUpdate: '最新更新',
    instDetailTotalValue: '总持仓市值',
    instDetailTabOverview: '持仓概览',
    instDetailTabHistory: '历史调仓',
    instDetailTabConcentration: '持仓集中度',
    instDetailStock: '股票',
    instDetailValue: '持仓市值',
    instDetailWeight: '占总仓位',
    instDetailShares: '持有股数',
    instDetailConcentration: '持仓集中度（前5）',
    instDetailAbout13f: '关于13F',
    instDetailAbout13fDesc: '管理资产超1亿美元的机构投资者须每季度向SEC提交13F报告，披露持仓情况。有约45天延迟。',
    instDetailRelatedStocks: '关联股票',
    instDetailDetail: '详情 →',
    instDetailLoading: '加载中...',
    instDetailNotFound: '未找到该机构数据',
    instDetailSource: '数据来源：SEC 13F 季报',
    instDetailSourceNote: '每季度更新一次（约45天延迟）',

    stockFundTitle: '上市公司基本面',
    stockFundSubtitle: '常驻监控 · 基本面摘要 · 财报日联动',
    stockFundCompany: '公司',
    stockFundTicker: '代码',
    stockFundRevenue: '最新季度营收',
    stockFundNetIncome: '净利润',
    stockFundNextEarnings: '下一财报日',
    stockFundRating: '评级',
    stockFundAction: '操作',
    stockFundViewDetail: '详情 →',
    stockFundRatingBuy: '买入',
    stockFundRatingHold: '持有',
    stockFundRatingWatch: '观望',
    stockFundLoading: '加载基本面数据...',
    stockFundError: '数据加载失败',
    stockFundSource: '数据来源：SEC EDGAR / Yahoo Finance',
  },

  nav: {
    profile: '个人中心',
    logout: '退出登录',
  },

  login: {
    title: '游领社区',
    emailPlaceholder: '邮箱',
    passwordPlaceholder: '密码',
    submit: '登录',
    submitting: '登录中...',
    register: '注册',
    forgotPassword: '忘记密码',
    fillAll: '请填写所有信息',
    invalidEmail: '邮箱格式不正确',
    userNotFound: '用户不存在',
    accountError: '账号数据异常，请联系管理员',
    wrongPassword: '密码错误',
    loginFailed: '登录失败',
    retryLater: '请稍后重试',
    validEmail: '请输入有效的邮箱地址',
  },

  register: {
    title: '注册账号',
    emailPlaceholder: '邮箱',
    passwordPlaceholder: '密码',
    confirmPasswordPlaceholder: '确认密码',
    inviteCodePlaceholder: '邀请码（选填）',
    submit: '注册',
    submitting: '注册中...',
    backToLogin: '返回登录',
    fillAll: '请填写所有信息',
    invalidEmail: '邮箱格式不正确',
    passwordTooShort: '密码长度至少需要8位',
    passwordMismatch: '两次密码不一致',
    emailExists: '该邮箱已注册',
    success: '注册成功',
    successMsg: '请使用邮箱和密码登录',
    reviewMsg: '注册已提交，请联系客服进行账号审核，审核通过后再使用受限工具。',
    goToLogin: '去登录',
    failed: '注册失败',
    validEmail: '请输入有效的邮箱地址',
    retryLater: '请稍后重试',
    confirm: '确定',
  },

  forgot: {
    title: '重置密码',
    emailPlaceholder: '邮箱',
    nextStep: '下一步',
    newPasswordPlaceholder: '新密码（至少 8 位）',
    confirmPasswordPlaceholder: '确认新密码',
    submit: '重置密码',
    submitting: '提交中...',
    backToLogin: '返回登录',
    enterEmail: '请输入邮箱',
    validEmail: '请输入有效的邮箱地址',
    emailNotRegistered: '该邮箱未注册',
    queryFailed: '查询失败',
    passwordRequirement: '密码要求',
    passwordTooShort: '新密码至少需要 8 位',
    passwordMismatch: '密码不一致',
    passwordMismatchMsg: '两次输入的密码不相同',
    success: '重置成功',
    successMsg: '密码已更新，请使用新密码登录',
    goToLogin: '去登录',
    failed: '重置失败',
    retryLater: '请稍后重试',
    confirm: '确定',
  },

  airdrop: {
    title: '空投活动',
    desc: '精选社区空投任务，查看奖励、时间和参与入口。',
    descLabel: '描述',
    startTime: '开始时间：',
    endTime: '结束时间：',
    tbd: '待定',
    statusUpcoming: '即将开始',
    statusOngoing: '进行中',
    statusEnded: '已结束',
    filterAll: '全部',
    filterOngoing: '进行中',
    filterUpcoming: '即将开始',
    filterEnded: '已结束',
    loading: '加载中...',
    noData: '暂无活动',
    rewardLabel: '奖励：',
    deadlineLabel: '截止：',
    viewDetail: '查看详情',
    backHome: '← 返回首页',
    eyebrow: 'Airdrop',
    overview: '空投概览',
  },

  profile: {
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    retryLater: '请稍后重试',
    confirm: '确定',
    refreshed: '已刷新',
    refreshFailed: '刷新失败',
    confirmLogout: '确认退出？',
    logout: '退出登录',
    cancel: '取消',
    copied: '已复制',
    points: '积分',
    verified: '已认证',
    unverified: '未认证',
    memberDays: '会员 {days} 天',
    inviteCode: '邀请码:',
    copy: '复制',
    refreshing: '刷新中...',
    refreshInfo: '刷新信息',
    personalInfo: '个人信息',
    guideTab: '完善指引',
    nickname: '昵称',
    nicknamePlaceholder: '请输入昵称',
    email: '邮箱',
    binanceUID: '币安 UID',
    binanceUIDPlaceholder: '请输入币安 UID',
    binanceUIDHint: '绑定币安交易所账户',
    bitgetUID: 'Bitget UID',
    bitgetUIDPlaceholder: '请输入 Bitget UID',
    bitgetUIDHint: '绑定 Bitget 交易所账户',
    wechat: '微信号',
    wechatPlaceholder: '请输入微信号',
    wechatHint: '用于客服联系和活动通知',
    okxUID: 'OKX UID',
    okxUIDPlaceholder: '请输入 OKX UID',
    okxUIDHint: '绑定 OKX 交易所账户',
    parentInviteCode: '父邀请码',
    none: '无',
    parentCodeHint: '注册时使用的邀请码',
    saving: '保存中...',
    save: '保存修改',
    logoutBtn: '退出登录',
    guideTitle: '注册完成后信息完善指引',
    guide1Title: '一、基础信息设置',
    guide1Nickname: '昵称：支持中英文及数字组合，2-12 字符，后续可修改。',
    guide1Email: '邮箱：绑定后不可修改，用于登录、密码找回、系统通知。',
    guide2Title: '二、交易所账户关联',
    guide2Binance: '币安 UID：登录币安 → 个人中心获取（纯数字标识）',
    guide2Bitget: 'Bitget UID：登录 Bitget → 个人中心获取',
    guide2Okx: 'OKX UID：登录 OKX → 个人中心获取',
    guide3Title: '三、邀请码说明',
    guide3Parent: '父邀请码：注册时使用的邀请码，用于追溯推荐关系。',
    guide3Mine: '我的邀请码：系统自动生成，分享给好友注册可获得邀请奖励。',
    guide4Title: '四、注意事项',
    guide4Note1: '请确保绑定的交易所 UID 为本人真实信息，虚假信息可能导致功能受限。',
    guide4Note2: '信息提交后 1-3 个工作日内完成审核，结果通过邮箱通知。',
    guide4Note3: '如有问题，添加客服微信 admiraltyz',
    userNotFound: '未找到用户记录',
    inviteCodeLabel: '邀请码:',
    advancedUser: '高级用户',
    premium: 'premium',
    shipping: {
      tab: '收件信息',
      title: '奖品收件信息',
      description: '只有资料完整且准确，才能获得需要快递寄送的奖品。',
      incomplete: '资料未完善',
      complete: '可用于奖品寄送',
      recipientName: '收件人姓名',
      recipientNamePlaceholder: '请输入真实收件人姓名',
      phone: '手机号码',
      phonePlaceholder: '请输入中国大陆 11 位手机号',
      invalidPhone: '请输入有效的中国大陆 11 位手机号',
      province: '省',
      provincePlaceholder: '例如：浙江省',
      city: '市',
      cityPlaceholder: '例如：杭州市',
      district: '区/县',
      districtPlaceholder: '例如：西湖区',
      addressDetail: '详细地址',
      addressDetailPlaceholder: '请填写街道、门牌号、楼栋和房间号',
      save: '保存收件信息',
      saving: '保存中...',
      loading: '正在加载收件信息...',
      loadFailed: '收件信息加载失败，请重试',
      retry: '重试',
      saveSuccess: '收件信息已保存',
      saveFailed: '收件信息保存失败',
    },
  },

  tools: {
    proBannerTitle: '解锁更多专业工具',
    proBannerDesc: '升级专业版，获取独家策略分析、高级回测工具和专属指导。',
    proBannerCta: '联系客服开通',
    patternTitle: 'K线形态匹配',
    patternSubtitle: 'Pattern Match',
    patternDesc: '截取最近一段 BTC K 线走势，自动匹配历史相似片段，直观查看后续真实涨跌表现，辅助判断行情方向。',
    detectiveTitle: '出货侦探 2.0',
    detectiveSubtitle: 'Dump Detective',
    detectiveDesc: '输入 BSC 代币合约地址，一键生成合约安全、流动性和出货风险侦测报告，避开 rug pull 陷阱。',
    levelsTitle: '支撑 / 压力位',
    levelsSubtitle: 'Support / Resistance',
    levelsDesc: '查询主流加密货币在多周期下的关键支撑与压力位，包含距离当前价的百分比和强度评级。',
    statusOnline: '已上线',
    btcHigh: '24h 最高',
    btcLow: '24h 最低',
    btcCap: '市值',
    btcVol: '24h 成交额',
  },

  docs: {
    bannerTitle: '交易学习',
    bannerDesc: '交易所教程 · 合约基础 · 推荐书籍',
    backToHome: '← 返回首页',
    backToList: '返回文档列表',
    all: '全部',
    prevDoc: '← 上一篇',
    nextDoc: '下一篇 →',
    pagination: '文档分页',
    prevPage: '上一页',
    nextPage: '下一页',
  },

  toolbox: {
    moreTools: '更多工具',
    continueExplore: '继续查看工具箱',
    defaultDesc: '这里会集中放置所有链上分析、行情回测和风险检测工具。',
    openToolbox: '打开工具箱',
    backToTools: '← 返回工具箱',
  },

  rebate: {
    bannerTitle: '用邀请码注册，每笔手续费永久返 20%',
    bannerDesc: '工具免费，账号也要选对。邀请码：',
    bannerCta: '免费注册返佣 →',
    kicker: '永久有效 · 邀请码 {code} · 2026 年可用',
    heroTitle: '手续费每天都在交，返佣一分没有拿',
    heroDesc: '使用各平台专属邀请码注册币安、OKX、Bitget、Gate，你交的每笔手续费都有固定比例返回账户。已经注册的账户，也可以按平台规则尝试补绑或换绑。',
    pickExchange: '选择交易所',
    viewRebind: '查看换绑方法',
    inviteCode: '邀请码',
    inviteCodeLabel: '邀请码',
    universalCode: '默认邀请码',
    codeHint: '注册时填入邀请码栏，返佣自动生效',
    overview: '返佣概览',
    statExchanges: '覆盖交易所',
    statRebate: '返佣范围',
    statCode: '默认邀请码',
    exchSubtitle: '选交易所，查返佣详情',
    exchTitle: '主流交易所返佣专区',
    exchDesc: '精选常用平台，整理注册步骤、换绑说明和返佣入口，方便你按自己的交易习惯选择。',
    viewTutorial: '查看{name}教程',
    feeSubtitle: '手续费率一目了然',
    feeTitle: '主流交易所费率横向对比',
    feeDesc: '费率会随 VIP 等级和平台政策调整，实际以下单页展示为准。',
    compareItem: '对比项',
    binance: '币安',
    okx: 'OKX',
    bitget: 'Bitget',
    gate: 'Gate',
    spotMaker: '现货 Maker',
    lowestFee: '最低费率',
    rebindSubtitle: '已注册但没填邀请码？',
    rebindTitle: '已注册账号也可以尝试补救',
    rebindDesc: '不同平台的换绑规则不同，建议先确认账户状态，再按对应教程处理。',
    rebindBinanceTitle: '币安换绑',
    rebindBinanceSubtitle: '3 种方法',
    rebindB1: '官方补绑链接',
    rebindB2: '删号重注',
    rebindB3: '90 天不活跃召回',
    rebindOkxTitle: 'OKX 换绑',
    rebindOkxSubtitle: '4 种方法',
    rebindO1: '无上级申请',
    rebindO2: '180 天闲置换绑',
    rebindO3: '大额用户通道',
    rebindBitgetTitle: 'Bitget 绑定',
    rebindBitgetSubtitle: '新号优先',
    rebindBg1: '注册时填写邀请码',
    rebindBg2: '检查账户返佣关系',
    rebindBg3: '绑定 UID 便于核对',
    rebindGateTitle: 'Gate 绑定',
    rebindGateSubtitle: '专属链接优先',
    rebindG1: '通过专属链接注册',
    rebindG2: '检查邀请关系',
    rebindG3: '保存 UID 便于核对',
    ctaTitle: '还在犹豫？每一天不填码都在亏手续费',
    ctaDesc: '返佣是长期现金流，不是一次性优惠。选择适合自己的平台，注册时使用对应的专属邀请码。',
    ctaBtn: '立即查看币安教程',
    breadcrumb: '面包屑导航',
    home: '首页',
    rebate: '交易所注册',
    detailHeroTitle: '别让手续费白白流走',
    viewSteps: '查看注册步骤',
    registerWithCode: '用 {code} 注册，开始赚返佣',
    viewRebindGuide: '先看换绑教程',
    whyChoose: '为什么选它',
    rebindGuideTitle: '换绑教程',
    newUserRegister: '新用户注册',
    stepsTitle: '注册步骤',
    openRegister: '打开{name}注册页面',
    extraBenefits: '补充福利',
    checkAfterRegister: '注册后顺手检查',
    rebateLabel: '返佣',
    directRegister: '直接注册',
    faqTitle: '常见问题',
    otherPlatforms: '其他平台',
  },

  community: {
    kicker: 'WEB3 社群',
    bannerTitle: '加入 GHOST 交易社群',
    bannerDesc: '和研究型交易者一起复盘行情、交流策略。DeBox 是类微信的加密交流工具，专属链接一键加入。',
    joinLabel: '加入社群',
    heroTitle: '加入 GHOST 交易社群',
    heroDesc: '和研究型交易者一起，把市场噪音变成可交流的信号。',
    hint: 'DeBox · 类微信的 Web3 加密交流工具',
    joinNow: '立即加入 DeBox',
    whatTitle: '什么是 DeBox',
    whatDesc: 'DeBox 是一款面向 Web3 的即时通讯与社群工具，体验接近微信，但为加密交易而生——链上身份、社群互动、活动分发集中在一个入口。我们用它作为 GHOST 社群的交流主场。',
    stepsTitle: '三步开始',
    step1Title: '点击加入',
    step1Desc: '通过本页专属链接进入 DeBox，确保来源可追踪。',
    step2Title: '注册或连接钱包',
    step2Desc: '按页面提示完成账号创建或钱包连接。',
    step3Title: '进群交流',
    step3Desc: '加入 GHOST 社群，复盘行情、分享信号、交流策略。',
    finaleTitle: '准备好了吗',
    servicesTitle: '你能获得什么',
    servicesDesc: '在 GHOST，学认知、判行情、并肩复盘——和研究型交易者一起成长。',
    service1Title: '系统学认知',
    service1Desc: '从财富底层逻辑到交易经典精读，把基础打牢；不懂随时问，有问有答。',
    service1Points: '财富认知体系 · 交易书籍精读 · 系统新手教程 · 即时答疑',
    service2Title: '关键行情，一起判断',
    service2Desc: '行情走到关键位置，社群第一时间分享解读——不只给结论，更讲清背后的逻辑。',
    service2Points: '关键位置解读 · 趋势/支撑阻力视角 · 判断逻辑分享 · 学会自己看懂',
    service3Title: '并肩复盘，长期同行',
    service3Desc: '和研究型交易者复盘讨论、交流策略、稳住心态；还有空投福利等社群专属活动。',
    service3Points: '复盘讨论 · 策略交流 · 心态陪伴 · 空投/福利',
  },

  patternMatch: {
    candleChartAriaLabel: 'K线图',
    overlayChartAriaLabel: '当前形态和历史最相似 Top5 叠加图',
    currentLabel: '当前',
    up: '上涨',
    down: '下跌',
    viewMatch: '查看匹配 #{rank}',
    matchScore: '匹配度',
    matchZone: '匹配区间',
    forwardZone: '后续区间',
    return: '收益',
    maxDrawdown: '最大回撤',
    maxRunup: '最大上涨',
    selectedCaseTitle: '选中案例大图 #{rank}',
    selectedCaseDesc: '匹配区间 {startDate} ~ {endDate}，后续观察至 {observationEndDate}',
    forwardReturn: '后续收益',
    caseDetailNote: '这张图用于核查单个历史案例的真实走势，不构成投资建议。',
    dataNotesTitle: '数据说明',
    toolReminder: '工具提醒',
    toolReminderDesc: '：历史形态匹配只是概率参考，行情源、同步过程或交易所接口有概率出现异常数据，请结合盘面和风险控制谨慎判断。',
    matchScoreDesc: '：由标准化走势的欧氏距离换算而来，值越高代表走势越相似。',
    matchZoneDesc: '：历史中被识别为相似形态的 K 线区间。',
    forwardZoneDesc: '：匹配区间结束之后继续观察的真实行情区间。',
    returnDesc: '：从匹配区间最后一根 K 线收盘价开始计算的涨跌幅。',
    maxDrawdownRunup: '最大回撤 / 最大上涨',
    maxDrawdownRunupDesc: '：后续区间内相对匹配结束收盘价的最大亏损和最大盈利。',
    historyLoadError: '无法加载市场历史 K 线数据',
    csvLoadError: '无法加载 BTC/USDT 1D CSV 数据',
    loading: '正在加载市场历史 K 线数据...',
    noCandleData: '没有可用 K 线数据',
    pageTitle: 'K线形态匹配',
    pageDesc: '用最近一段真实市场 K 线匹配历史相似形态，查看后续真实涨跌表现。',
    symbolLabel: '交易对',
    intervalLabel: '周期',
    updatedAt: '更新',
    patternLengthLabel: '形态长度',
    forwardWindowLabel: '后续观察',
    exclusionWindowLabel: '排除最近',
    matchCount: '匹配数量',
    top5UpRatio: 'Top5 上涨比例',
    avgForwardReturn: '平均后续收益',
    medianReturn: '中位数收益',
    avgMaxDrawdown: '平均最大回撤',
    currentVsTop5: '当前形态 vs 历史最相似 Top5',
    currentVsTop5Desc: '左侧是当前 K 线，右侧是标准化 Bar 走势对比。',
    latestClose: '最新收盘',
    dayUnit: '日',
    barUnit: '根K线',
    currentCandleTrend: '当前 K 线趋势',
    barNormalizedSimilarity: 'Bar 标准化相似走势',
    top5DetailTitle: 'Top 5 匹配详情',
    top5DetailDesc: '红色背景为匹配区间之后的真实后续走势，蓝色虚线是匹配结束点。',
    dumpDetectiveLink: '出货侦探 2.0',
    supportResistanceLink: '支撑 / 压力位',
    toolboxDescription: '形态匹配、风险检测和支撑压力位分析，辅助你的交易决策。',
  },

  detective: {
    errorChainNotOpen: '该链暂未开放，当前仅支持 BSC。',
    errorInvalidAddress: '请输入有效的 BSC 合约地址（0x 开头的 42 位十六进制字符）',
    title: '出货侦探 2.0',
    description: '输入代币合约地址，一键生成链上风险侦测报告。',
    tagContract: '合约安全',
    tagLiquidity: '流动性',
    tagHolders: '持仓结构',
    selectChain: '选择链',
    available: '可用',
    notAvailable: '暂未开放',
    tokenContractAddress: '代币合约地址',
    startDetect: '开始侦测',
    exampleBabyDoge: '示例：BabyDoge',
    footnote: '本工具仅用于链上风险检测，不构成投资建议。数据来自公开链上信息，可能存在延迟。',
    toolboxDescription: '风险检测、形态匹配和支撑压力位分析，辅助你的交易决策。',
    patternMatch: 'K线形态匹配',
    supportResistance: '支撑 / 压力位',
  },

  detectiveReport: {
    scoreContract: '合约安全',
    scoreLiquidity: '流动性健康',
    scoreHolders: '持仓结构',
    scoreProject: '项目方行为',
    scoreSmartMoney: '聪明钱信号',
    scoreMarket: '市场活跃度',
    notConnected: '暂未接入',
    yes: '是',
    no: '否',
    safetyScoreOutOf100: '安全分 / 100',
    overallRating: '综合评级',
    safetyGaugeDesc: '分数越高代表合约和资金池越安全。',
    riskRadar: '风险雷达图',
    dataNotFullyConnected: '数据暂未完全接入，部分维度展示为空。',
    dexscreenerQuote: 'DexScreener 行情',
    connected: '已接入',
    fetchFailed: '获取失败',
    mainPoolDex: '主池 DEX',
    noData: '暂无数据',
    mainPoolAddress: '主池地址',
    contractOpenSource: '合约开源',
    suspectedHoneypot: '疑似貔貅盘',
    mintable: '可增发',
    blacklistMechanism: '黑名单机制',
    ownerNotRenounced: 'Owner 未放弃权限',
    buySellTax: '买税 / 卖税',
    holderData: '持仓数据',
    detectionDetails: '详细检测项',
    backToDetect: '返回重新侦测',
    errorBscOnly: '当前仅支持 BSC EVM 合约地址。',
    errorApiFailed: '分析接口请求失败。',
    generatingReport: '正在生成风险报告',
    generatingReportDesc: '正在请求 Cloudflare Function 分析链上数据...',
    cannotGenerateReport: '无法生成报告',
    reportDataEmpty: '报告数据为空。',
    price: '价格',
    change24h: '24h 涨跌',
    liquidity: '流动性',
    volume24h: '24h 成交量',
    riskWarnings: '风险警告',
    ruleSummary: '规则总结',
    summaryDisclaimer: '本工具仅用于链上风险检测，不构成投资建议。',
    toolboxDescription: '完成本次风险检测后，可继续使用其他工具。',
    patternMatch: 'K线形态匹配',
    supportResistance: '支撑 / 压力位',
  },

  levels: {
    interval15m: '15 分钟',
    interval1h: '1 小时',
    interval4h: '4 小时',
    interval1d: '1 天',
    toolPatternMatch: 'K线形态匹配',
    toolDumpDetective: '出货侦探 2.0',
    seconds: '秒',
    minutes: '分',
    priceCloserTip: '距离当前价越近，参考意义越大',
    price: '价格',
    distance: '距当前价',
    strength: '强度',
    touches: '触达次数',
    strength_strong: '强',
    strength_medium: '中',
    strength_weak: '弱',
    touchesCount: '{count} 次',
    rateLimitRemaining: '剩余 {remaining} / {limit} 次',
    rateLimitDisabled: '已达查询上限，请稍后重试',
    currentPrice: '当前价格',
    updated: '已更新',
    queryInterval: '查询周期',
    binanceKlineTip: '数据来源：币安 K 线',
    queryQuota: '查询额度',
    quotaCooldownTip: '每次查询后需等待冷却',
    unsupportedSymbol: '暂不支持该币种',
    queryFailed: '查询失败，请稍后重试',
    pageTitle: '支撑 / 压力位',
    pageDesc: '查询主流加密货币在多周期下的关键支撑与压力位。',
    multiInterval: '多周期',
    symbol: '币种',
    querying: '查询中...',
    queryBtn: '查询',
    popular: '热门',
    selectInterval: '选择周期',
    querySettings: '查询设置',
    querySettingsDesc: '选择币种和周期，获取关键价位数据',
    pleaseWait: '请等待 {time}',
    resistance: '压力位',
    noResistances: '暂无压力位数据',
    support: '支撑位',
    noSupports: '暂无支撑位数据',
    nearby: '附近的价位',
    noNearby: '暂无附近价位数据',
    dataDisclaimer: '数据说明',
    dataDisclaimerDesc: '数据来自币安 K 线历史，仅供参考，不构成投资建议。',
    notInvestAdvice: '不构成投资建议',
    toolboxDesc: '支撑压力位、形态匹配和风险检测，辅助你的交易决策。',
  },

  social: {
    title: '社区动态',
    desc: '来自 X 的最新观点与市场分析',
    viewSource: '查看原文',
    viewAll: '查看全部',
    navLabel: '动态',
    empty: '暂无动态',
    loading: '加载中...',
    sectionTitle: '社区动态',
    sectionDesc: '来自 X 的最新观点',
    postedAt: '{time}',
    imageAlt: '动态图片',
  },

  instList: {
    title: '机构持仓 13F',
    desc: '追踪全球顶级机构的最新季度持仓变动，数据来源 SEC EDGAR，每季度更新。',
    loading: '正在加载机构持仓数据...',
    filingDate: '报告日期',
    totalValue: '总持仓市值',
    holdingsCount: '持仓数量',
    topHoldings: '前三大持仓',
    viewDetail: '查看完整持仓',
    source: '数据来源：SEC EDGAR 公开披露，仅供参考，不构成投资建议。',
  },

  fundPage: {
    title: '上市公司基本面',
    desc: '基于 SEC EDGAR XBRL 财务数据，展示美股龙头公司最新季度核心财务指标。',
    loading: '正在加载基本面数据...',
    error: '数据加载失败，请稍后重试',
    company: '公司',
    ticker: '代码',
    revenue: '营收',
    netIncome: '净利润',
    growth: '营收增长',
    eps: 'EPS',
    grossProfit: '毛利润',
    operatingIncome: '营业利润',
    nextEarnings: '下次财报',
    rating: '评级',
    ratingBuy: '买入',
    ratingHold: '持有',
    ratingWatch: '观望',
    viewDetail: '详情',
    source: '数据来源：SEC EDGAR 公司财务事实（Company Facts）/ Yahoo Finance quote，仅供参考，不构成投资建议。',
  },

  lang: {
    zh: 'C',
    en: 'N',
  },

  cs: {
    label: '客服',
    title: '联系客服',
    copyTip: '点击复制微信号',
    copied: '已复制',
    feedback: '反馈建议',
    comingSoon: '即将上线',
  },
};

export default zh;
